import clsx from "clsx";
import type { GridPreset } from "../../types";

const PRESETS: GridPreset[] = [1, 4, 9, 16, 25, 36, 49, 64];

interface Props {
  value: GridPreset;
  onChange: (p: GridPreset) => void;
  disabled?: boolean;
}

export function LayoutPicker({ value, onChange, disabled }: Props) {
  return (
    <div className="flex items-center gap-1 bg-panel border border-line rounded p-0.5">
      {PRESETS.map((p) => (
        <button
          key={p}
          disabled={disabled}
          className={clsx(
            "px-2 py-0.5 text-xs rounded",
            value === p ? "bg-accent text-white" : "text-text hover:bg-line",
            disabled && "opacity-40 cursor-not-allowed",
          )}
          onClick={() => onChange(p)}
          title={`${p} canales`}
        >
          {p}
        </button>
      ))}
    </div>
  );
}
